export default __webpack_public_path__ + "8dcb45b7deca2d823eaf4b621b5843ee.png";